module.exports = __webpack_public_path__ + "static/media/Circle.2cb2ac35.svg";